import api from "./api";

export const getConversionReport = (funnelId, startDate, endDate) => {
    const params = { funnelId };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    return api.get("/reports/conversion", { params });
};

export const getPerformanceReport = (funnelId, startDate, endDate) => {
    const params = { funnelId };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    return api.get("/reports/performance", { params });
};

export const getProductReport = (funnelId, startDate, endDate) => {
    const params = { funnelId };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    return api.get("/reports/products", { params });
};

export const getOriginReport = (funnelId, startDate, endDate) => {
    const params = { funnelId };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    return api.get("/reports/origin", { params });
};

export const getTimeReport = (funnelId, startDate, endDate) => {
    const params = { funnelId };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    return api.get("/reports/time", { params });
};

export const getRankingReport = (funnelId, startDate, endDate) => {
    const params = { funnelId };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    return api.get("/reports/ranking", { params });
};

export const getLeadsReport = (funnelId, startDate, endDate) => {
    const params = { funnelId };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    return api.get("/reports/leads", { params });
};
